import axios from 'axios'
// const baseurl='https://yekjapi.wghuang.work'
// 昕生文化
// const baseurl='https://xsapi.wghuang.work'
const baseurl='https://cms.ytjdv.com'
export default {
//通用
getcommerlist(params,url,method,Token,obj) {
    if(method=='get'){
      axios({
        method: method,
        url: baseurl+url,
        params: params,
        headers: { 'X-Litemall-Admin-Token': Token}
      }).then(res => {
        // console.log(res)
        return obj(res.data)
      })
    }else{
      axios({
        method: method,
        url: baseurl+url,
        data: params,
        headers: { 'X-Litemall-Admin-Token': Token}
      }).then(res => {
        // console.log(res)
        return obj(res.data)
      })
    }
  },
  getcommerdata(params,url,method,Token,obj){
    axios({
      method: method,
      url: baseurl+url,
      data: params,
      headers: { 'X-Litemall-Admin-Token': Token}
    }).then(res => {
      // console.log(res)
      return obj(res.data)
    })
  },
  postOther(params,url,method,Token,obj){
    axios({
      method: method,
      url: baseurl+url,
      params: params,
      headers: { 'X-Litemall-Admin-Token': Token}
    }).then(res => {
      // console.log(res)
      return obj(res.data)
    })
  },
  // 获取缓存
  GetSessionStorage(key) {
    return new Promise(resolve => {
      const isCached = JSON.parse(localStorage.getItem(key))
      resolve(isCached)
    })
  },
  // 缓存
  setItem (key, val) {
    localStorage.setItem(key, JSON.stringify(val));
  },
  removeItem (key) {
    localStorage.removeItem(key);
  },
  clear () {
    localStorage.clear();
  },
  //获取小程序码
  postgetScheme(scene,pages,obj) {
    axios({
      method: 'get',
      url: 'https://cms.ytjdv.com/wx/home/getScheme',
      params: {scene:scene,pages:pages},
      headers: {'Content-Type': 'application/json'}
    }).then(res => {
      console.log(res)  
      return obj(res.data)
    })
  },
}